import type { FC, PropsWithChildren, ReactNode } from 'react';
import type { ColSize } from '@george-labs.com/design-system/types/components/Layout';
import { LabeledListItem } from '@george-labs.com/design-system';

import { useProductsListContext } from './ProductsListContext';

interface Props {
    'data-cy'?: string;
    className?: string;
    label?: ReactNode;
    labelClassName?: string;
    labelColumnWidth?: ColSize;
}

export const ProductsListItemWrapper: FC<PropsWithChildren<Props>> = ({
    'data-cy': dataCy,
    className,
    label,
    labelClassName,
    labelColumnWidth,
    children,
}) => {
    const { labelClassName: labelClassNameFromList, labelColumnWidth: labelColumnWidthFromList } =
        useProductsListContext();

    return (
        <LabeledListItem
            data-cy={`${dataCy}-label`}
            className={className}
            label={label}
            labelClassName={labelClassName ?? labelClassNameFromList}
            labelColumnWidth={labelColumnWidth ?? labelColumnWidthFromList}
        >
            {children}
        </LabeledListItem>
    );
};
